export const DEFAULT_STATE = {
    lastSignUps: null,
    date: new Date(),
    activityType: '',
    activities: [],
    rangeStartDate: null,
    rangeEndDate: null,
    isOpen: false,
    enrollmentsForClasses: null,
    enrollmentsForCamps: null,
    enrollmentsForAftercare: null,
    totalRefund: null,
    totalRevenue: null,
    revenuePerDates: []
};


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/default-state.js